import { faArrowTurnDownRight } from "@fortawesome/pro-solid-svg-icons";

import { Icon } from "src/base-components/Icon";

const ACCESS_MESSAGE_PARTS = {
  prefix: "data.",
  caseField: "case",
} as const;

export const CaseFieldAccessInfo: React.FC = () => {
  return (
    <div className="mt-2 mb-3 ml-4 flex gap-x-1">
      <Icon color="text-gray-500" icon={faArrowTurnDownRight} size="sm" />
      <p className="font-inter-normal-12px">
        You can access this case in your decision flow via{" "}
        <span className="text-indigo-600">{ACCESS_MESSAGE_PARTS.prefix}</span>
        <span className="text-green-600">{ACCESS_MESSAGE_PARTS.caseField}</span>{" "}
        field.
      </p>
    </div>
  );
};
